<template>
  <div v-scroll="onScroll" :class="breakpoint">
    <v-toolbar app flat fixed height="80">
      <img src="@/assets/balance_MC.svg" />
      <h2 v-if="offsetTop >= 90 || !notHome">MC Consultant</h2>
      <v-toolbar-items class="txt-menus" v-if="$vuetify.breakpoint.lgAndUp">
        <button flat @click="homepage()" v-t="'Commun.Accueil'" />
        <router-link to="/presentation" tag="button" v-t="'Commun.Qui'" />
        <router-link to="/prestations" tag="button" v-t="'Commun.Prestations'" />
        <button flat @click="scrollToActuality()" v-t="'Commun.Blog'" />
        <router-link to="/tarifs" tag="button" v-t="'Commun.Tarifs'" />
        <button flat @click="scrollToContact()" v-t="'Commun.Contact'" />
      </v-toolbar-items>
      <v-toolbar-items v-if="$vuetify.breakpoint.mdAndDown">
        <!-- <contact-icons btn-size="36px" icon-size="18" /> -->
        <v-menu offset-y :nudge-bottom="10">
          <v-btn icon slot="activator" class="ml-3">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list class="dropdown-menu">
            <v-list-tile @click="homepage()">{{ $t('Commun.Accueil') }}</v-list-tile>
            <v-list-tile to="/presentation" tag="button">{{ $t('Commun.Qui') }}</v-list-tile>
            <v-list-tile to="/prestations" tag="button">{{ $t('Commun.Prestations') }}</v-list-tile>
            <v-list-tile @click="scrollToActuality()">{{ $t('Commun.Blog') }}</v-list-tile>
            <v-list-tile to="/tarifs" tag="button">{{ $t('Commun.Tarifs') }}</v-list-tile>
            <v-list-tile @click="scrollToContact()">{{ $t('Commun.Contact') }}</v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-container fluid> 
      <router-view />
    </v-container>

    <div class="py-2 text-xs-center mentions-link" v-if="!isMentions" @click="$router.push('/mentionslegales')"
      :class="isTarifs ? 'primary--text' : 'primary white--text'">
        mentions légales
    </div>
  </div>
</template>

<script>
export default {
  name: 'layout',
  data () {
    return {
      offsetTop: 0
    }
  },
  computed: {
    breakpoint () {
      return {
        'xsOnly': this.$vuetify.breakpoint.xsOnly,
        'smOnly': this.$vuetify.breakpoint.smOnly,
        'mdOnly': this.$vuetify.breakpoint.mdOnly
      }
    },
    actualityHeight () {
      if (this.$vuetify.breakpoint.xsOnly) return 900
      if (this.$vuetify.breakpoint.smOnly) return 1150
      if (this.$vuetify.breakpoint.mdAndUp) return 1100
      return 1100
    },
    notHome () {
      return this.$route.name === 'home'
    },
    isMentions () {
      return this.$route.name === 'mentionslegales'
    },
    isTarifs () {
      return this.$route.name === 'tarifs'
    }
  },
  methods: {
    onScroll () {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
    },
    homepage () {
      this.$router.push('/')
      window.scrollTo(0, 0)
    },
    scrollToContact () {
      let bottom = document.body.scrollHeight
      window.scrollTo(0, bottom)
      this.$router.push('/')
    },
    scrollToActuality () {
      this.$router.push('/')
      window.scrollTo(0, this.actualityHeight)
    }
  }
}
</script>

<style lang="stylus">
.mentions-link
  position absolute
  bottom 0
  width 100%
  font-size 11px
  text-decoration underline
  cursor pointer
</style>


